import React from 'react';
import CustomTable from '../../../../../components/table/CustomTable';
import { VisitorTabTableApp } from '../Functionality/VisitorTabTableApp';
import { VISITOR_VIEWS_FROM } from '../../Guard/Model/Model';
import VisitorMainHeader from './VisitorMainHeader';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const VisitorTabTable = (props) => {
    const {
        selectedList,
        setSelectedList,
        view,
        setView,
        searchElement, setSearchElement,
        setBodyForExport,
        finalArray,
        setFinalArray,
        search, setSearch,
        viewOrigin,
        getChildrenNotInformation,
        subView,
        handleSubViewChange,
        setSearchResults,
        setCriteria,
        setDeleteModal,
        goUpdate,
        modified,
        setModified,
        setShowRequestAccessModal,
        isAllChecked,
        setIsAllChecked,
        setSimpleSearch
    } = props;

    const {
        DEV,
        permission,
        setResults,
        option,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        deletePermission,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons
    } = VisitorTabTableApp({
        selectedList,
        setSelectedList,
        setCriteria,
        searchElement,
        finalArray,
        setDeleteModal,
        goUpdate,
        modified,
        setModified,
        viewOrigin,
        setShowRequestAccessModal,
        setBodyForExport,
        setIsAllChecked,
        view,
    });

    return (
        <>
            <VisitorMainHeader
                DEV={DEV}
                permission={permission}
                view={view}
                setView={setView}
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray}
                setResults={setResults}
                viewOrigin={viewOrigin}
                setIsAllChecked={setIsAllChecked}
                setCriteria={setCriteria}
            />

            <div className={"mt-3"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={deletePermission}
                    checkboxTitle={'de_/_select_all'}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    childrenNotInformation={getChildrenNotInformation(VISITOR_VIEWS_FROM.VISITOR_GUARD)}
                />
                {pagination()}
            </div>
        </>
    );
};

export default VisitorTabTable;
